<template>
	<div class="pagelist"> 
        <span class="jump"v-show="current_page>1" @click="jumpPage(current_page-1)"> < </span> 
        <span v-show="indexs[0]>1" class="jump" @click="jumpPage(1)">1</span> 
        <span class="ellipsis"  v-show="efont">...</span> 
        <span class="jump" v-for="num in indexs" :class="{bgprimary:current_page==num}" @click="jumpPage(num)">{{num}}</span> 
        <span class="ellipsis"  v-show="efont&&current_page<totalPage-4">...</span> 
 
        <span class="jump" v-show="current_page<totalPage" @click="jumpPage(current_page+1)"> > </span> 
        <span v-show="totalPage < indexs[indexs.length-1]" class="jump"  @click="jumpPage(totalPage)"> {{totalPage}} </span> 
 
        <!-- <span class="jumppoint">跳转到：</span> 
        <span class="jumpinp"><input type="text" v-model="changePage"></span> 
        <span class="jump gobtn" @click="jumpPage(changePage)">GO</span>  -->
    </div> 
</template>
<script>
	export default{
		name:"",
		props:['totalPage','page'],
		data(){
			return {
				current_page: 1, //当前页 
			    pages: 1, //总页数 
			    //changePage:'',//跳转页 
			    //nowIndex:0 
			}
		},
		computed:{ 
		     show:function(){ 
		         return this.pages && this.pages !=1 
		     }, 
		     efont: function() { 
		       if (this.pages <= 7) return false; 
		       return this.current_page > 5 
		     }, 
		     indexs: function() { 
		 
		       var left = 1, 
		         right = this.pages, 
		         ar = []; 
		       if (this.pages >= 7) { 
		         if (this.current_page > 5 && this.current_page < this.pages - 4) { 
		           left = Number(this.current_page) - 3; 
		           right = Number(this.current_page) + 3; 
		         } else { 
		           if (this.current_page <= 5) { 
		             left = 1; 
		             right = 7; 
		           } else { 
		             right = this.pages; 
		 
		             left = this.pages - 6; 
		           } 
		         } 
		       } 
		       while (left <= right) { 
		         ar.push(left); 
		         left++; 
		       } 
		       return ar; 
		     }, 
		   }, 
		methods: { 
		    jumpPage: function(id) { 
		      this.current_page = id; 
		      this.$emit('changePage',id);
		    }, 
		}, 
		created(){
			if(this.page) this.current_page = this.page;
			if(this.totalPage) this.pages = this.totalPage;
		},
		mounted(){

		}
	}
</script>
<style scoped>
	.page { 
	  font-weight: 900; 
	  height: 40px; 
	  text-align: center; 
	  color: #888; 
	  margin: 20px auto 0; 
	  background: #f2f2f2; 
	} 
	 
	.pagelist { 
	  font-size: 0; 
	  background: #fff; 
	  height: 50px; 
	  line-height: 50px; 
	} 
	 
	.pagelist span { 
	  font-size: 14px; 
	} 
	 
	.pagelist .jump { 
	  border: 1px solid #ccc; 
	  padding: 5px 10px; 
	  -webkit-border-radius: 1px; 
	  -moz-border-radius: 1px; 
	  border-radius: 1px; 
	  cursor: pointer; 
	  margin-left: 5px; 
	} 
	 
	.pagelist .bgprimary { 
	  cursor: default; 
	  color: #fff; 
	  background: #c72729; 
	  border-color: #c72729; 
	} 
	 
	.jumpinp input { 
	  width: 55px; 
	  height: 26px; 
	  font-size: 13px; 
	  border: 1px solid #ccc; 
	  -webkit-border-radius: 4px; 
	  -moz-border-radius: 4px; 
	  border-radius: 4px; 
	  text-align: center; 
	} 
	 
	.ellipsis { 
	  padding: 0px 8px; 
	} 
	 
	.jumppoint { 
	  margin-left: 30px; 
	} 
	 
	.pagelist .gobtn {} 
	 
	.bgprimary { 
	  cursor: default; 
	  color: #fff; 
	  background: #337ab7; 
	  border-color: #337ab7; 
	}
</style>